/**
 * Kontekst nagrania do strojenia (SPEC §23.40): jaki kod, jakie progi i jakie ustawienia Azure wydały werdykt zapisany przy nagraniu. Bez tego późniejsze porównanie
 * „stary werdykt kontra nowe progi” nie miałoby punktu odniesienia (progi w `config.ts` zmieniają się w trakcie strojenia).
 */
import { config } from '../config.ts';
import { ASSESS_SETTINGS } from '../speech/azureSettings.ts';
import { BUILD_ID } from './buildInfo.ts';

export interface RecordingContext {
  /** Wersja kodu (skrót commita z `vite build`; `dev` poza buildem). */
  build: string;
  /** User-Agent urządzenia (skrócony) — mikrofony iPada i Maca wypadają inaczej, a to przydaje się przy analizie. */
  ua?: string;
  /** Progi oceny (`config.scoring`) w chwili próby. */
  scoring: Record<string, number | boolean>;
  /** Ustawienia Azure (język, ocena głosek, bramka…) w chwili próby. */
  azure: Record<string, string | number | boolean>;
}

const MAX_UA = 200;

export function recordingContext(scope: { navigator?: { userAgent?: unknown } } = globalThis as { navigator?: { userAgent?: unknown } }): RecordingContext {
  const scoring: Record<string, number | boolean> = {};
  for (const [k, v] of Object.entries(config.scoring)) if (typeof v === 'number' || typeof v === 'boolean') scoring[k] = v;
  const ua = scope.navigator?.userAgent;
  return { build: BUILD_ID, ...(typeof ua === 'string' && ua !== '' ? { ua: ua.slice(0, MAX_UA) } : {}), scoring, azure: { ...ASSESS_SETTINGS } };
}
